export default __webpack_public_path__ + "static/media/argentan13.afd87965.jpg";